import { render, staticRenderFns } from "./SchoolSystemConfig.vue?vue&type=template&id=86c9b6e0&scoped=true"
import script from "./SchoolSystemConfig.vue?vue&type=script&lang=js"
export * from "./SchoolSystemConfig.vue?vue&type=script&lang=js"
import style0 from "./SchoolSystemConfig.vue?vue&type=style&index=0&id=86c9b6e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c9b6e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86c9b6e0')) {
      api.createRecord('86c9b6e0', component.options)
    } else {
      api.reload('86c9b6e0', component.options)
    }
    module.hot.accept("./SchoolSystemConfig.vue?vue&type=template&id=86c9b6e0&scoped=true", function () {
      api.rerender('86c9b6e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SchoolSystemConfig.vue"
export default component.exports